import React, { Fragment } from 'react';
import { Authenticator } from './Auth/Authenticator';
import { DynamicHomePage } from './SignedOutDynamicHome';
import { NavigationBar } from './NavigationBar';
import { MeLoader } from './User';



function HomePageLoader(props) {
    return(
        <Authenticator hideDefault="true">
            <DynamicHomePage></DynamicHomePage>
        </Authenticator>);
}

/*function HomePageSwitcher(props) {
    if(props.authState !== 'signedIn') {
        return (
            <Fragment>
                <SignedOutDynamicHomePage></SignedOutDynamicHomePage>
            </Fragment>
        );
    }
    return (<HomePage></HomePage>);
}

function HomePage(props) {
    return(
        <div>
            <MeLoader></MeLoader>
        </div>
    );
}*/

export { HomePageLoader };
